__webpack_require__.p = "https://admin.nori.ma/";